import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { LabelFotosLaudosTecnicosModel } from "../laudos-tecnicos/label-fotos-laudostecnicos.model";
import { LabelFotosLaudosTecnicosService } from "../laudos-tecnicos/label-fotos-laudostecnicos.service";
import { Funcoes } from "../funcoes";
import { Global } from "../global";
import { MercadoriasService } from "../mercadorias/mercadorias.service";


@Component({
  selector: 'app-label-fotos-laudostecnicos-form',
  templateUrl: './label-fotos-laudostecnicos-form.component.html'
})
export class LabelFotosLaudosTecnicosFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  labelFoto: LabelFotosLaudosTecnicosModel = new LabelFotosLaudosTecnicosModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;
  listMercadorias = [];
  mercadoriasSelecionadas = [];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private labelFotosService: LabelFotosLaudosTecnicosService,
    private mercadoriasService: MercadoriasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome_pt: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
      nome_en: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
      nome_es: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
      id_mercadoria: [null],
      ordem: [null]
    });
  }

  ngOnInit() {

    this.mercadoriasService.get().subscribe(res => this.listMercadorias = res.Payload);

    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_label_foto'];

      if(!this.pageIsUpd && !this.pageIsAdd){
        this.title = this.func.traduzir('front.visualizarLabelFoto');
      }else if(this.pageIsUpd){
        this.title = this.func.traduzir('front.editarLabelFoto');
      }else{
        this.title = this.func.traduzir('front.cadastrarNovaLabelFoto');
      }

      if (!id) {
        return;
      }

      this.labelFotosService.getById(id, ['mercadorias'])
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarLabelFoto')+': '+json.Payload[0].nome_pt;
            }else if(!this.pageIsAdd){
              this.title = this.func.traduzir('front.visualizarLabelFoto') + ': ' + json.Payload[0].nome_pt;
            }

            this.labelFoto = json.Payload[0];
            if (this.labelFoto.mercadorias) {
              this.mercadoriasSelecionadas = this.labelFoto.mercadorias.map(m => m.id);
            } else {
              this.mercadoriasSelecionadas = [];
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  addMercadoria() {
    let totalDisponivel = this.listMercadorias ? this.listMercadorias.length : 0;
    if (this.mercadoriasSelecionadas.length >= totalDisponivel) {
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.todasMercadoriasJaAdicionadas'), 'erro');
      return;
    }
    this.mercadoriasSelecionadas.push(null);
  }

  removeMercadoria(i) {
    this.mercadoriasSelecionadas.splice(i, 1);
  }

  getMercadoriasDisponiveis(indexAtual: number) {
    if (!this.listMercadorias) return [];
    return this.listMercadorias.filter(m => {
      let findIdx = this.mercadoriasSelecionadas.findIndex(id => id != null && String(id) === String(m.id));
      return findIdx === -1 || String(m.id) === String(this.mercadoriasSelecionadas[indexAtual]);
    });
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id_mercadoria === 'null' || values.id_mercadoria === '') {
      values.id_mercadoria = null;
    }

    values.mercadorias = this.mercadoriasSelecionadas.filter(id => id != null);

    if (values.id) {
      result = this.labelFotosService.editar(values, values.id);
    } else {
      result = this.labelFotosService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'laudos-tecnicos', 'labels-fotos']),
      error => {
        this.enviando = false;
        let json = error.json();
        this.func.showErro(json);

        if(json.Message && json.Message.ErrorInput){
          for(let i in json.Message.ErrorInput){
            let erro = {};
            erro[i] = json.Message.ErrorInput[i];
            this.form.controls[i].setErrors(erro);
          }
        }
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/label-fotos-laudostecnicos/label-fotos-laudostecnicos-form.component.ts